import { Route, Routes } from "react-router";
import Api from "./Api";
import AuthPages from "../Layouts/AuthPages";
import _SignIn from "./SignIn";
import _ForgotPassword from "./ForgotPassword";
import _Invitation from "./Invitation";
import Profile from "./Profile";
import IdealRole from "./IdealRole";
import ApplyingRoleSetup from "./ApplyingRole";
import CVSetup from "./CVSetup";
import _Home from "./Home";
import _Achievements from "./Achievements";
import _JobApplications from "./JobApplications";
import _AccountSettings from "./AccountSettings";
import _CVs from './CVs';
import AccountFrameLayout from "./AccountFrameLayout";
import PageLayout from "../Layouts/PageLayout";
import withInsight from "../Hooks/withApplicationInsight";
import useConfirmMessageDisplay from "../Hooks/useConfirmMessageDisplay";
import useProfileCompletionCheck from "../Hooks/useProfileCompletionCheck";
import LoadingScreen from "../Components/Generic/LoadingSpinner";

const SignIn = withInsight(AuthPages(_SignIn));
const ForgotPassword = withInsight(AuthPages(_ForgotPassword));
const Invitation = withInsight(AuthPages(_Invitation));
const Home = withInsight(PageLayout(_Home));
const Achievements = withInsight(PageLayout(_Achievements));
const JobApplications = withInsight(PageLayout(_JobApplications));
const AccountSettings = withInsight(PageLayout(_AccountSettings));
const CVs = withInsight(PageLayout(_CVs));

export {
    Api, AccountFrameLayout, SignIn, ForgotPassword, Invitation,
    Home, Achievements, Profile, AccountSettings, IdealRole,
    ApplyingRoleSetup, JobApplications, CVs, CVSetup
};



export function AuthRoutes({ children }) {
  return (
    <Routes>
      <Route path="sign-out" element={<LoadingScreen fullScreen/>}/>
      <Route path="sign-in" element={<SignIn/>}/>
      <Route path="invitation" element={<Invitation/>}/>
      <Route path="forgot-password" element={<ForgotPassword/>}/>
      <Route path="*" element={children}/>
    </Routes>
  )
}

export default function ApplicationRoutes() {
  useConfirmMessageDisplay();
  useProfileCompletionCheck();
  return (
    <Routes>
      <Route path="profile" element={<Profile/>}>
        <Route path=":step" element={<Profile/>}/>
      </Route>
      <Route path="achievements" element={<Achievements/>}/>
      <Route path="account-settings" element={<AccountSettings/>}/>
      <Route path="ideal-job" element={<IdealRole/>}>
        <Route path=":step" element={<IdealRole/>}/>
      </Route>
      <Route path="applying-job-setup" element={<ApplyingRoleSetup/>}>
        <Route path=":step" element={<ApplyingRoleSetup/>}>
          <Route path=":id" element={<ApplyingRoleSetup/>}/>
        </Route>
      </Route>
      <Route path="cv-setup" element={<CVSetup/>}>
        <Route path=":id" element={<CVSetup/>}/>
      </Route>
      <Route path="job-applications" element={<JobApplications/>}>
        <Route path=":id" element={<JobApplications/>}/>
      </Route>
      <Route path="cvs" element={<CVs/>}/>
      <Route path="*" element={<Home/>}/>
    </Routes>
  );
}
